import React from 'react'
import { Card } from 'antd'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { getContractTypeName } from '../../utils/functions'

const CardContrato = (props) => {

    const { contract, active } = props

    return (
        <Link to={`/contrato/${contract.id}`}>
            <Card className={`contract-card ${!active ? 'contract-card-inactive' : ''}`}>
                <h3 className="tx-pink font-bold">{getContractTypeName(contract.tipoContrato)} {(contract.tipoContrato !== 6 && contract.tipoContrato !== 7 && contract.tipoContrato !== 19) && `| ${contract.duracao} meses`}</h3>
                <label className="tx-pink font-bold">ID <span className="tx-gray font-bold ml-5">#{contract.id}</span></label><br />
                <label className="tx-pink font-bold mt-10">Vencimento</label><br />
                <span className="tx-gray font-16">{getContractTypeName(contract.tipoContrato) === 'RLY' || getContractTypeName(contract.tipoContrato) === 'RFY-Classe Sub.' || getContractTypeName(contract.tipoContrato) === 'RLY3' ? 'Indeterminado' : moment(contract.dataFim).format("DD/MM/YYYY")}</span>
            </Card>
        </Link>
    )
}

export default CardContrato